<template>
  <div>
		<v-tabs
			right
			dark
			color="cyan"
			class="mt-5"
		>
			<v-tab
				v-for="tab in tabs"
				:key="tab.id"
				active-class="active-tab"
			>
				{{ tab.name }}
			</v-tab>
			<v-tab-item
				v-for="tab in tabs"
				:key="tab.id"
			>
				<v-layout
					row
					wrap
					v-if="tab.id === 1"
					ma-5>
					<v-flex xs12 mb-3 v-if="flagCompanyParent">
						<v-flex xs5>
							<v-select
								box
								solo
								background-color="white"
								class="body-1"
								hide-details
								label="Compañía maestra"
								item-text="nombreComercial"
								item-value="id"
								:items="masterCompanies"
								v-model="model.masterCompany"
							></v-select>
						</v-flex>
					</v-flex>
					<v-flex xs5 mr-5 mb-3>
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="Nombre Comercial"
							required
							v-model="model.nameCommercial"
							:error="$v.model.nameCommercial.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs5>
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="Razón Social"
							v-model="model.businessName"
							:error="$v.model.businessName.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs5 mr-5>
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="Código de Compañia"
							v-model="model.codeCompany"
							:error="$v.model.codeCompany.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs5 mb-3>
						<v-select
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="País"
							item-text="name"
							item-value="id"
							:items="countries"
							v-model="model.country"
						></v-select>
					</v-flex>
					<v-flex xs11 mb-3>
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="Ruc"
							type="number"
							v-model="model.ruc"
							:error="$v.model.ruc.$error"
						>
						</v-text-field>
						<span class="form-group__message" v-if="!$v.model.ruc.required">
							Es necesario llenar este campo, es obligatorio.
						</span>
						<span class="form-group__message" v-if="!$v.model.ruc.minLength">
							Mínimo 13 caracteres numericos.
						</span>
					</v-flex>
					<v-layout row pl-2>
						<v-flex
							xs3
							v-for="(value, key) in languages"
							:key="key"
						>
							<v-checkbox
								color="cyan"
								:label="key"
								v-model="value.isSelected"
							>
							</v-checkbox>
						</v-flex>
						<v-checkbox
								color="cyan"
								label="Franquicia"
								v-model="flagFranchises"
							>
							</v-checkbox>
						<v-checkbox
								color="success"
								label="Kardex"
								v-model="flagKardex"
							>
						</v-checkbox>
					</v-layout>
					<v-flex xs11 mb-3 v-if="flagKardex === true">
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="Cantidad de Recalculos Kardex"
							type="number"
							v-model="recalculateKardex"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs11>
						<v-select
							box
							solo
							background-color="white"
							class="body-1 mt-2"
							box
							hide-details
							item-text="name"
							item-value="id"
							label="Planes"
							:items="plans"
							v-model="model.plan"
							return-object
						></v-select>
						<span class="form-group__message" v-if="!$v.model.plan.required">
							Es necesario escoger un plan.
						</span>
					</v-flex>
				</v-layout>
				<v-layout v-else row wrap ma-5 >
					<v-flex xs12 mb-3>
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="Email"
							v-model="model.email"
							:error="$v.model.email.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 mb-3>
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="User"
							v-model="model.codeUser"
							:error="$v.model.codeUser.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 mb-3>
						<v-text-field
							box
							solo
							background-color="white"
							class="body-1"
							hide-details
							label="Password"
							type="password"
							v-model="model.password"
							:error="$v.model.password.$error"
						>
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-tab-item>
		</v-tabs>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="$v.$invalid || loading"
				:on-run-service="loading"
				@accept-button-clicked="sendData"
				@cancel-button-clicked="closeModal"
			/>
		</section>
  </div>
</template>

<script>
import { required, email, minLength } from 'vuelidate/lib/validators';
import helper from '@/shared/helper';

const { getLocalData } = helper;

function validations() {
	const validation = {
		model: {
			nameCommercial: {
				required,
			},
			businessName: {
				required,
			},
			codeCompany: {
				required,
			},
			ruc: {
				required,
				minLength: minLength(13),
			},
			email: {
				required,
				email,
			},
			password: {
				required,
			},
			codeUser: {
				required,
			},
			plan: {
				required,
			},
		},
	};
	return validation;
}

function closeModal() {
	this.goTo('page-template', { params: { projectId: this.projectId, codeProject: this.codeProject } });
}

async function created() {
	this.idProject = this.projectId || getLocalData('project-id');
	this.templateCode = this.codeTemplate || getLocalData('code-template');
	const requests = [
		this.$http.get(`project/${this.idProject}`),
		this.$http.get('countries'),
	];
	const [{ data: record }, { data: response }] = await Promise.all(requests);
	this.countries = response.data;
	this.languages = record.data.languages;
	this.isCompanyParent(record.data);
	this.loadTemplatePlans();
}

async function loadTemplatePlans() {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const idTemplate = this.$route.params.id;
	try {
		const { data: response } = await this.$http.get(`template/${idTemplate}`, { headers });
		this.plans = response.data.plans;
	} catch (error) {
		this.showError();
	}
}

function isCompanyParent({ flagCompanyParent }) {
	if (flagCompanyParent) {
		this.flagCompanyParent = flagCompanyParent;
		this.loadMasterCompanies();
	}
}

async function loadMasterCompanies() {
	const params = { page: 1 };
	const url = `/projects/${this.codeProject}/company-parent`;
	const { data: response } = await this.$http.get(url, { params });
	this.masterCompanies = response.data;
}

async function sendData() {
	this.loading = true;
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};

	const body = {
		codeCompany: this.model.codeCompany,
		codeProject: this.codeProject,
		codeTemplate: this.templateCode,
		codeUser: this.model.codeUser,
		companyParentId: this.model.masterCompany,
		countryId: this.model.country,
		email: this.model.email,
		flagFranchises: this.flagFranchises,
		recalculateKardex: this.recalculateKardex,
		flagKardex: Number(this.flagKardex),
		flagAppCompany: true,
		languages: this.languages,
		nombreComercial: this.model.nameCommercial,
		password: this.model.password,
		razonSocial: this.model.businessName,
		ruc: this.model.ruc,
		plans: this.model.plan.id,
	};
	try {
		await this.$http.post('company-template', body, { headers });
		this.showNotification('Se creó correctamente el template');
		this.closeModal();
	} catch (err) {
		if (err.data.email) {
			this.showError(err.data.email);
		}
		if (err.data.codeUser) {
			this.showError(err.data.codeUser);
		}
		if (err.data.codeCompany) {
			this.showError(err.data.codeCompany);
		}
	} finally {
		this.loading = false;
	}
}

function data() {
	return {
		countries: [],
		flagCompanyParent: 0,
		idProject: 0,
		flagFranchises: false,
		loading: false,
		flagKardex: false,
		recalculateKardex: 0,
		masterCompanies: [],
		model: {
			businessName: '',
			codeCompany: '',
			codeUser: '',
			country: '',
			email: '',
			masterCompany: 0,
			nameCommercial: '',
			password: '',
			ruc: '',
			plan: '',
		},
		tabs: [
			{ id: 1, name: 'Datos Compañía' },
			{ id: 2, name: 'Datos Usuario' },
		],
		templateCode: 0,
		plans: [],
	};
}
export default {
	name: 'template-form',
	created,
	data,
	methods: {
		closeModal,
		isCompanyParent,
		loadMasterCompanies,
		sendData,
		loadTemplatePlans,
	},
	props: {
		projectId: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
		codeTemplate: {
			type: [Number, String],
		},
	},
	validations,
};
</script>
<style lang="scss" scoped>
.active-tab {
	color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/template/template-form.vue